module.exports = __webpack_public_path__ + "static/img/section2-image01.6491d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-mb/page2/section2-image01.jpg
// module id = WLxr
// module chunks = 1